export default {
}



// WEBPACK FOOTER //
// ./src/store/modules/sidebar/actions.js